/*
 *
 * NotificationContainer constants
 *
 */

export const DEFAULT_ACTION = "app/NotificationContainer/DEFAULT_ACTION"
export const UPDATE_BADGE = "app/NotificationContainer/UPDATE_BADGE"
export const MARK_ALL = "app/NotificationContainer/MARK_ALL"
export const MARK_AS_READ = "app/NotificationContainer/MARK_AS_READ"
export const FETCH_NOTIFICATIONS =
  "app/NotificationContainer/FETCH_NOTIFICATIONS"
export const FETCH_NOTIFICATIONS_SUCCESS =
  "app/NotificationContainer/FETCH_NOTIFICATIONS_SUCCESS"
export const FETCH_NOTIFICATIONS_FAILED =
  "app/NotificationContainer/FETCH_NOTIFICATIONS_FAILED"
export const GO_TO_NOTIFICATION = "app/NotificationContainer/GO_TO_NOTIFICATION"
export const GO_TO_NOTIFICATION_SUCCESS =
  "app/NotificationContainer/GO_TO_NOTIFICATION_SUCCESS"

export const SET_ALL_READ = "app/NotificationContainer/SET_ALL_READ"
export const SET_ALL_READ_SUCCESS =
  "app/NotificationContainer/SET_ALL_READ_SUCCESS"

export const SET_COUNT = "app/NotificationContainer/SET_COUNT"
